/* App.js */
// var React = require('react');
import React from "react";
import ReactApexChart from 'react-apexcharts'
// let words = [];
let wo=[]
class Charts extends React.Component {
  
  // componentDidMount(){
  //   wo=[];
  //   console.log(this.props.info)
  //   for (var i = 0; i < this.props.nword; i++) {
  //     this.setState({ 
  //       words: this.state.words.concat( this.props.info[i][0])
  //     })
  //       wo.push(this.props.info[i][1])
  //   }
  //   // wo = this.state.words
  //   console.log("hereras")
    
  // // }




  // }
  constructor(props) {
    super(props);
    // console.log(wo)
    // console.log(wo.length)
    this.state = {
      // words:[],
      series: [{
        name: 'احتمال',
        type: 'column',
        data: this.props.prop
      }, {
        name: 'فراوانی',
        type: 'column',
        data: this.props.freq
      }, 
      // {
      //   name: 'Revenue',
      //   type: 'line',
      //   data: [20, 29, 37, 36, 44, 45, 50, 58]
      // }
    ],
      options: {
        chart: {
          height: 350,
          // width:1,
          // style: {
            // fontSize: "140px",
            fontFamily: "Btitr",
            // fontWeight: "bold"
          // },
          type: 'line',
          stacked: false
        },
        dataLabels: {
          // enabled: false,
          enabled: false,
          style: {
            // fontSize: "140px",
            fontFamily: "Bnazanin",
            // fontWeight: "bold"
          }
        },
        stroke: {
          width: 0
        },
        title: {
          text: 'موضوع      '+this.props.topic_id,
          align: 'center',
          offsetX: 10,
          style: {
            fontFamily: "Btitr",
          }
        },
        
        xaxis: {
          categories: this.props.words,
          style: {
            fontFamily: "Btitr",
          }
        },
        yaxis: [
          {
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#000000'
            },
          
            title: {
              text: "احتمال",
              style: {
                color: '#000000',
                fontFamily: "Btitr",
              }
            },
            tooltip: {
              enabled: false
            }
          },
          {
            seriesName: 'توزیع',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#000000'
            },
            labels: {
              style: {
                Left:"10%",
                colors: '#000000',
                // fontFamily: "Bnazanin",
              }
            },
            title: {
              text: "فراوانی",
              style: {
                color: '#000000',
                fontFamily: "Btitr",
              }
            },
          },
          // {
          //   seriesName: 'Revenue',
          //   opposite: true,
          //   axisTicks: {
          //     show: true,
          //   },
          //   axisBorder: {
          //     show: true,
          //     color: '#FEB019'
          //   },
          //   labels: {
          //     style: {
          //       colors: '#FEB019',
          //     },
          //   },
          //   title: {
          //     text: "Revenue (thousand crores)",
          //     style: {
          //       color: '#FEB019',
          //     }
          //   }
          // },
        ],
        
        legend: {
          horizontalAlign: 'left',
          offsetX: 40
        }
      },
    
    
    };
  }
 


  render() {
   
// if (this.state.words.length > 0) {
    return (
      

  <div id="chart" style={{margin:"auto", fontFamily: 'Bnazanin',}} >
<ReactApexChart style={{fontFamily: 'Bnazanin',}} options={this.state.options} series={this.state.series} type="line" height={350} />
{/* <div>hello</div> */}
</div>




    );
  // }

  // else{
//     return(
//       <div>
// hello
//       </div>

//     )
    

//   }
  }
}

export default Charts
// module.exports = Charts;   